import { Partial } from '@40seas/entities/common';
import { RutterValidation } from './rutter-validation.entity';

export class UpdateRutterValidationDto extends Partial(RutterValidation) {}
